module.exports = __webpack_public_path__ + "static/media/homem_r2_c7.e1d5c087.jpg";